import React from 'react';
import PromoCodes from '../../components/AdminNext/PromoCodes';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Promo codes — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <PromoCodes />
      </HeadLessLayout>
    )
  };
}

export default action;
